<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-listar #ctrl URL="otro-pago?tipos_movimientos_id=2&otros_pagos=true" titulo="Venta"></app-listar>

<!-- Menu principal "-->
<sistema-menu *ngIf="!persona"></sistema-menu>

<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda" *ngIf="!persona">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- Opciones y busqueda -->
            <tabla-opciones [ctrl]="ctrl" *ngIf="!persona"></tabla-opciones>

            <div id="exportar_datos" [style]="!persona ? 'overflow-y:auto; overflow-x: hidden; display:block; height: 78.4vh;' : ''" >
              <a id="imprimirTicket" (click)="ctrl.imprimeTicket(ctrl.json)"></a>

                <!--Tabla -->
                <table class="table is-striped  is-fullwidth" *ngIf="ctrl.tipo_grid && !ctrl.cargando">
                    <thead>
                        <tr>
                            <th>Folio </th>
                            <th>Fecha</th>
                            <th>Cliente </th>
                            <th>Importe</th>
                            <th>Capturo</th>
                            <th>Comentario</th>
                            <th width="1%" class="no_pdf">Opciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of ctrl.dato; let i=index">
                            <td style="vertical-align: middle;">{{item.folio}} </td>
                            <td style="vertical-align: middle;">{{ item.created_at }} </td>
                            <th style="vertical-align: middle;">
                                <span *ngIf="item.personas">{{item.personas.nombre}}</span>
                            </th>
                            <td style="vertical-align: middle;">
                                {{item.total | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                                <span style="color:red" *ngIf="item.total_devolucion > 0">Dev: {{item.total_devolucion | currency:ctrl.configuracion.sucursal.moneda:'symbol' }}</span>
                                <span style="color:green" *ngIf="item.total_devolucion > 0">Total: {{item.total - item.total_devolucion | currency:ctrl.configuracion.sucursal.moneda:'symbol' }}</span>
                            </td>
                            <td style="vertical-align: middle;">{{ item.usuarios.nombre }} </td>
                            <td style="vertical-align: middle;">{{ item.comentarios }} </td>
                            <td style="vertical-align: middle;" class="has-text-centered no_pdf">
                                <!-- acciones -->
                                <a (click)="calcular_importe_articulo(item, ctrl.json)" id="funcion_secundaria{{i}}"></a>
                                <app-tabla-acciones [item]="item" [index]="i" [ctrl]="ctrl" class="level-left"></app-tabla-acciones>
                            </td>

                        </tr>
                        <tr *ngIf="ctrl.dato.length == 0">
                            <td colspan="5" style="vertical-align: middle; color:#888;">Esta lista está vacía.</td>
                        </tr>
                    </tbody>

                </table>

                <!--Lista -->
                <span *ngIf="!ctrl.tipo_grid && !ctrl.cargando" class="lista_lista">
                    <div class="box" *ngFor="let item of ctrl.dato; let i=index" style="margin-bottom:0.1rem;" [style.background]="i%2 == 0 ? '#fafafa' : '#ffffff'">
                        <article class="media">
                            <div class="media-left">
                                <figure class="image is-64x64">
                                    <img src="./assets/128x128.png" alt="Image">
                                </figure>
                            </div>
                            <div class="media-content">
                                <div class="content">
                                    <p>

                                        <strong class="tag is-info is-medium" style="font-size:12pt">Folio: {{item.folio}}</strong>
                                        <strong class="tag is-dark is-medium" style="font-size:12pt">Codigo: {{item.codigo}}</strong>
                                        <strong class="tag is-dark is-medium">Fecha de entrega: {{item.created_at}}</strong>
                                        <strong class="tag is-primary is-medium" style="font-size:12pt">Cliente:
                                            <span *ngIf="item.personas">{{item.personas.nombre}}</span>
                                        </strong>
                                        <strong class="tag is-medium">
                                            Importe: {{item.total | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                                            <span style="color:red" *ngIf="item.total_devolucion > 0">Dev: {{item.total_devolucion | currency:ctrl.configuracion.sucursal.moneda:'symbol' }}</span>
                                            <span style="color:green" *ngIf="item.total_devolucion > 0">Total: {{item.total - item.total_devolucion | currency:ctrl.configuracion.sucursal.moneda:'symbol' }}</span>
                                        </strong>

                                        <strong class="tag is-default is-medium">Capturo: {{item.usuarios.nombre}}</strong>
                                        <strong class="tag is-default is-medium">Comentario: {{item.comentarios}}</strong>
                                        <a (click)="calcular_importe_articulo(item, ctrl.json)" id="funcion_secundaria{{i}}"></a>
                                    </p>
                                </div>
                                <nav class="level is-mobile" style="float:right">
                                    <div class="level-left">

                                        <!-- acciones -->
                                        <app-tabla-acciones [item]="item" [index]="i" [ctrl]="ctrl" class="level-left"></app-tabla-acciones>
                                    </div>
                                </nav>
                            </div>
                        </article>
                    </div>
                </span>
              </div>
            <!-- Paginación para la lista  -->
            <app-paginacion [ctrl]="ctrl"></app-paginacion>
        </div>

    </div>
</div>

<div style="display:none" id="imprimir">
    <div dir="ltr" *ngIf="ctrl.json">
        <p align="center" style="margin-bottom:0cm;line-height:100%">
            <br>
        </p>
        <p align="center" style="margin-bottom:0cm;line-height:100%">
            <br>
        </p>
        <p align="center">
            <font >
                {{ctrl.configuracion.empresa.nombre}}</font>
        </p>
        <p align="center">
            <font >
                {{ctrl.configuracion.empresa.direccion}}
            </font>
        </p>
        <p align="center" style="font-weight:normal">
            <br>
        </p>
        <hr style="border:2px dashed black;width:100%">
        <p align="center" style="font-style:normal;font-weight:normal">
            <font >{{ctrl.configuracion.sucursal.nombre}}
            </font>
        </p>
        <p align="center" style="font-style:normal;font-weight:normal">
            <font >{{ctrl.configuracion.sucursal.direccion}}</font>
        </p>
        <p align="center" style="font-style:normal;font-weight:normal">
            <font >Tel: {{ctrl.configuracion.sucursal.telefono}} Correo: {{ctrl.configuracion.sucursal.correo}}</font>
        </p>
        <hr style="border:2px dashed black;width:100%">
        <p align="left"> </p>


        <p align="right">
            <font >
                <span style="font-weight:normal">CODIGO : {{ctrl.json.codigo}}</span>
                <b> </b>
            </font>
        </p>

        <p align="right" style="font-weight:normal">
            <font >
                <span style="font-weight:normal">FECHA : </span>
                <b>{{ctrl.json.created_at | formatoFecha}} </b>
            </font>
        </p>

        <p align="right" style="font-weight:normal" *ngIf="ctrl.json.personas">
            <font >
                <span style="font-weight:normal">CLIENTE : </span>
                <b>{{ctrl.json.personas.nombre}} </b>
            </font>
        </p>

        <hr style="border:2px dashed black;width:100%">
        <p align="center" style="margin-bottom:0cm;line-height:100%">
            <br>
        </p>
        <p align="center" style="margin-bottom:0cm;line-height:100%">
            <font >
                <b>VENTA</b>
            </font>
        </p>

        <p align="left">
            <br>
        </p>
        <table width="100%" cellpadding="4" cellspacing="0" class="table is-striped  is-fullwidth">
            <tr valign="top">
                <td width="25%" style="border:none;padding:0cm">
                    CANT.
                </td>
                <td width="25%" style="border:none;padding:0cm">
                    PRECIO
                </td>
                <td width="25%" style="border:none;padding:0cm">
                    DESCUENTO
                </td>
                <td width="25%" style="border:none;padding:0cm">
                    IMPORTE
                </td>
            </tr>
        </table>
        <div *ngFor="let item of ctrl.json.movimientos_articulos">
            <strong>({{item.articulos.clave}}) {{item.articulos.nombre}}</strong>
            <table width="100%" cellpadding="4" cellspacing="0" class="table is-striped  is-fullwidth">
                <tr valign="top">
                    <td width="25%">{{item.cantidad}}</td>

                    <td width="25%">{{item.precio_unitario}}</td>
                    <td width="25%">{{item.descuento}}%</td>
                    <td width="25%">{{item.precio_con_descuentos | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}</td>
                </tr>
            </table>
            <hr style="padding:0px; margin:0px;">
        </div>
        <div *ngIf="ctrl.json.devoluciones.length > 0">
            <p align="center" style="margin-bottom:0cm;line-height:100%">
                <font>
                    <b>DEVOLUCIÓN</b>
                </font>
            </p>

            <p align="left">
                <br>
            </p>


            <div *ngFor="let dev of ctrl.json.devoluciones">

                <table width="100%" cellpadding="4" cellspacing="0" class="table is-striped  is-fullwidth">
                    <tr valign="top">
                        <td width="25%" style="border:none;padding:0cm">
                            CANT.
                        </td>
                        <td width="25%" style="border:none;padding:0cm">
                            PRECIO
                        </td>
                        <td width="25%" style="border:none;padding:0cm">
                            DESCUENTO
                        </td>
                        <td width="25%" style="border:none;padding:0cm">
                            IMPORTE
                        </td>
                    </tr>
                </table>
                <div *ngFor="let item of dev.movimientos.movimientos_articulos">
                    <strong>({{item.articulos.clave}}) {{item.articulos.nombre}}</strong>
                    <table width="100%" cellpadding="4" cellspacing="0" class="table is-striped  is-fullwidth">
                        <tr valign="top">
                            <td width="25%">{{item.cantidad}}</td>

                            <td width="25%">{{item.precio_unitario}}</td>
                            <td width="25%">{{item.descuento}}%</td>
                            <td width="25%">{{item.precio_con_descuentos | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}</td>
                        </tr>
                    </table>
                    <hr style="padding:0px; margin:0px;">
                </div>
            </div>
        </div>
        <p align="center" style="margin-bottom:0cm;line-height:100%">
            <br>
        </p>

        <div>
            <p align="right" style="font-weight:normal">
                <strong>
                    <font>SUBTOTAL</font>

                </strong>
                <font>
                    {{ctrl.json.subtotal | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                </font>
            </p>
        </div>
        <div *ngIf="ctrl.json.descuento > 0">
            <p align="right" style="font-weight:normal">
                <strong>
                    <font>Descuento</font>

                </strong>
                <font>
                    {{ctrl.json.descuento | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                </font>
            </p>
        </div>
        <div>
            <p align="right" style="font-weight:normal">
                <strong>
                    <font >TOTAL</font>

                </strong>
                <font >
                    {{ctrl.json.total | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                </font>
            </p>
        </div>
        <div *ngFor="let moneda of ctrl.configuracion.sucursal.conversiones_monedas">
            <p align="right" style="font-weight:normal">
                <strong>
                    <font >{{moneda.nombre}}</font>

                </strong>
                <font >
                    {{(ctrl.json.total / moneda.tipo_cambio) | currency:moneda.moneda:'symbol'}}
                </font>
            </p>
        </div>
        <div *ngFor="let p of ctrl.json.pagos">
            <p align="right" style="font-weight:normal">
                <strong>
                    {{p.tipos_formas_pagos.nombre }}
                </strong>
                <font>
                    {{p.importe | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                </font>
            </p>
            <p align="right" style="font-weight:normal">
                <font>
                    {{p.tipos_metodos_pagos.nombre }}
                </font>
            </p>
            <hr style="border:1px dashed black;width:100%">
        </div>
        <div *ngIf="ctrl.json.cambio">
            <p align="right" style="font-weight:normal">
                <strong>
                    <font >CAMBIO</font>

                </strong>
                <font >
                    {{ctrl.json.cambio | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                </font>
            </p>
            <div *ngFor="let moneda of ctrl.configuracion.sucursal.conversiones_monedas">
                <p align="right" style="font-weight:normal">
                    <strong>
                        <font >{{moneda.nombre}}</font>

                    </strong>
                    <font >
                        {{(ctrl.json.cambio / moneda.tipo_cambio) | currency:moneda.moneda:'symbol'}}
                    </font>
                </p>
            </div>
        </div>

        <p align="center" style="margin-bottom:0cm;line-height:100%">
            <br>
        </p>
        <p align="left">
            <font>
                <span style="font-weight:normal">
                    ATENDIÓ :
                </span>
                <span style="font-weight:normal">
                    {{ctrl.json.usuarios.nombre}}
                </span>
            </font>
        </p>
        <p align="center" style="font-weight:normal">
            <font>
                Gracias por su compra
            </font>
        </p>
        <p align="center">
            <img [src]="'data:image/png;base64,' + ctrl.json.barcode">
        </p>
    </div>
</div>
